module.exports = __webpack_public_path__ + "assets/images/confirm-email@2x.3ab728899d31d065a90d103d133c2773.webp";